module.exports = __webpack_public_path__ + "static/media/APP01@l.78564bdb.jpg";